import Cookies from 'universal-cookie';
import { deleteCart, deleteFavourites } from '../Services/localStorage';

export const Logout = () => {
    const cookies = new Cookies();
    cookies.remove('user')
    deleteCart();
    deleteFavourites()
    window.location.href = '/'
    return (
        <></>
    )
}